// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HThw","field":"styles_field__Dv1lS","fieldCol":"styles_fieldCol__39Qum","diffCol":"styles_diffCol__3259a","diff":"styles_diff__3bv0E"};